import {
  GET_ATTENDANTS,
  GET_BAR_DATA,
  GET_CALENDAR_DATA,
  GET_PIE_DATA,
  GET_PLACES,
  GET_QUEUE,
  GET_SERVICES,
  QUEUE_INITIAL_RECIEVED
} from "./../actions/types";
import { all, put, takeLatest } from "redux-saga/effects";

import axios from "axios";

function* fetchAttendant() {
  const attendants = yield axios
    .get("https://sinapse.ufpi.br/saps/api/servidores/all")
    .then(res => res);

  attendants.data.sort((a, b) => (a.pessoa.nome < b.pessoa.nome ? -1 : 1));

  yield put({ type: "ATTENDANTS_RECIEVED", data: attendants.data });
}

function* fetchPlaces() {
  const places = yield axios
    .get("https://sinapse.ufpi.br/saps/api/chamados/unidades")
    .then(res => res);

  const placesFilter = [];
  places.data.map(place =>
    placesFilter.filter(placeF => placeF.id === place.idUnidadeRaiz).length ===
    0
      ? placesFilter.push({
          id: place.idUnidadeRaiz,
          name: place.nomeUnidadeRaiz
        })
      : null
  );
  placesFilter.unshift({ id: 0, name: "Todos" });
  placesFilter.sort((a, b) => a.id - b.id);
  // placesFilter.unshift({ id: cuid(), name: "Todos" });

  yield put({ type: "PLACES_RECIEVED", data: places.data });
  yield put({ type: "FILTER_PLACES_SENT", data: placesFilter });
}

function* fetchInitialQueue() {
  const queue = yield axios
    .get("https://sinapse.ufpi.br/saps/api/chamados/fila-inicial")
    .then(res => res);

  queue.data.sort((a, b) => b.id - a.id);

  yield put({ type: "QUEUE_INITIAL_RECIEVED", data: queue.data });
}

function* fetchQueue() {
  const queue = yield axios
    .get("https://sinapse.ufpi.br/saps/api/chamados/fila")
    .then(res => res);

  queue.data.sort((a, b) => b.id - a.id);

  yield put({ type: "QUEUE_RECIEVED", data: queue.data });
}

function* fetchServices() {
  const services = yield axios
    .get("https://sinapse.ufpi.br/saps/api/servicos/73/listFloor")
    .then(res => res);

  yield put({ type: "SERVICES_RECIEVED", data: services.data });
}

function* fetchPieData() {
  const pieData = yield axios
    .get("https://sinapse.ufpi.br/saps/api/indicadores/chamados-situacao")
    .then(res => res);

  yield put({ type: "PIE_DATA_RECIEVED", data: pieData.data });
}

function* fetchBarData() {
  const barData = yield axios
    .get("https://sinapse.ufpi.br/saps/api/indicadores/chamados-unidade")
    .then(res => res);

  yield put({ type: "BAR_DATA_RECIEVED", data: barData.data });
}

function* fetchCalendar() {
  const sti = yield axios
    .get("https://sinapse.ufpi.br/saps/api/calendar/STI - Superintendência de Tecnologia da Informação")
    .then(res => res)
      .catch(err=> err);

  const ci = yield axios
    .get("https://sinapse.ufpi.br/saps/api/calendar/ci")
    .then(res => res)
      .catch(err=> err);

  const cs = yield axios
    .get("https://sinapse.ufpi.br/saps/api/calendar/cs")
    .then(res => res)
      .catch(err=> err);

  const calendarData = {
    sti: normalizeCalendar(sti.data),
    ci: normalizeCalendar(ci.data),
    cs: normalizeCalendar(cs.data)
  };

  yield put({ type: "CALENDAR_RECIEVED", data: calendarData });
}

const normalizeCalendar = data => {

  if(!data){return}
  const normalizedData = [];


  // eslint-disable-next-line array-callback-return
  data.map((event, index) => {
    normalizedData.push({
      id: index,
      title: event.summary,
      start: event.start? new Date(event.start): null,
      end: event.end? new Date(event.end):null
    });
  });
  console.log(normalizedData);
  return normalizedData;
};

function* actionWatcher() {
  yield takeLatest(GET_ATTENDANTS, fetchAttendant);
  yield takeLatest(GET_PLACES, fetchPlaces);
  yield takeLatest(GET_QUEUE, fetchInitialQueue);
  yield takeLatest(QUEUE_INITIAL_RECIEVED, fetchQueue);
  yield takeLatest(GET_SERVICES, fetchServices);
  yield takeLatest(GET_PIE_DATA, fetchPieData);
  yield takeLatest(GET_BAR_DATA, fetchBarData);
  yield takeLatest(GET_CALENDAR_DATA, fetchCalendar);
}

export default function* rootSaga() {
  yield all([actionWatcher()]);
}
